// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/index'
import router from './router/premission'
import DcSelect from '@/components/dc-select'
import ElementUI from 'element-ui'
import mamchargeUi from 'vue-mamcharge-ui'
import service from '@/utils/http-service'
import './styles/element-variables.scss'
import '@/styles/base.css'
import '@/styles/public.scss'
import '@/styles/transition.scss'
import '@/icon-menu/iconfont.css'
import VueAreaLinkage from 'vue-area-linkage'
import 'vue-area-linkage/dist/index.css'
import VueCropper from 'vue-cropper' // 图片裁剪

import * as filters from './filters'
import bus from '@/utils/eventBus'
Vue.use(VueAreaLinkage)
Vue.prototype.$http = service
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(mamchargeUi)
Vue.use(VueCropper)
Vue.component('dc-select', DcSelect)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.toKeyValue = function(arr) {
  const obj = {}
  arr.forEach(el => {
    obj[el.value + ''] = el.label
  })
  return obj
}
// 全局引入事件总线
Vue.prototype.bus = bus
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js